import { debounceTime, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { UserSettingsAction } from '../userSettings.action';
import { userSettingsStoreSelector } from '../userSettings.selector';
import { SAVE_SETTINGS_DEBOUNCE_MS } from '../userSettings.constant';
import { IUserSettingsStoreSegment } from '../userSettings.interface';

type IDependencies = IClientApiDependencySegment;

/**
 * The reducer merges each saveSetting optimistically; here bursts of changes are
 * debounced and the full settings object is PATCHed (the endpoint is an upsert that
 * stores the body as-is, so the whole object is always sent). switchMap: latest wins.
 */
export const saveUserSettingsEpic: IEpic<IUserSettingsStoreSegment, IDependencies> = (action$, state$, { api }) => action$.pipe(
  isTypeOf(UserSettingsAction.saveSetting),
  debounceTime(SAVE_SETTINGS_DEBOUNCE_MS),
  withLatestFrom(state$),
  switchMap(([, state]) => {
    const { settings } = userSettingsStoreSelector(state);

    return api.saveUserSettings({ settings }).pipe(
      map(() => UserSettingsAction.save.done({ params: settings, result: undefined })),
      catchApiError((error) => [
        UserSettingsAction.save.failed({ params: settings, error }),
        createApiErrorNotification(error),
      ]),
    );
  }),
);
